import { CalendarBlankIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const DateTime = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <CalendarBlankIcon size={Sizes[size]} {...rest} color={fill} />;
};

DateTime.displayName = 'DateTime';
